import { jsx } from "@emotion/react/jsx-runtime";
import _styled from "@emotion/styled/base";
import { forwardRef } from "react";
import parseStyle from "./parseStyle.mjs";
import Clickable from "./Clickable.mjs";
import useThemeProps from "./useThemeProps.mjs";
const ButtonRoot = /* @__PURE__ */_styled(Clickable, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: prop => !["style", "hoverStyle", "focusStyle", "activeStyle", "disabledStyle", "activeHoverStyle"].includes(prop),
  target: "e172ud7k0"
} : {
  shouldForwardProp: prop => !["style", "hoverStyle", "focusStyle", "activeStyle", "disabledStyle", "activeHoverStyle"].includes(prop),
  target: "e172ud7k0",
  label: "ButtonRoot"
})(_ref => {
  let {
    theme
  } = _ref;
  return theme.styleUtils.buttonReset;
}, "border:1px solid transparent;border-radius:0.25rem;padding:0.5rem 0.75rem;display:inline-flex;place-content:center;place-items:center;gap:0.25rem;font-weight:600;font-size:inherit;line-height:1.25em;--icon-color:currentColor;&.wsui-is-interactive:not(input:disabled + &.wsui-is-interactive:is(label)){cursor:pointer;}", _ref2 => {
  let {
    theme,
    style
  } = _ref2;
  return parseStyle(style, theme);
}, " &.wsui-is-interactive:hover:not(input:disabled + &.wsui-is-interactive:is(label)),&:focus,input:focus+&:is(label){", _ref3 => {
  let {
    theme,
    hoverStyle
  } = _ref3;
  return parseStyle(hoverStyle, theme);
}, ";}&:focus-visible,input:focus-visible+&:is(label){", _ref4 => {
  let {
    theme,
    focusStyle
  } = _ref4;
  return parseStyle(focusStyle, theme);
}, ";}&.wsui-is-interactive:active:not(\n      input:disabled + &.wsui-is-interactive:is(label)\n    ),&[aria-current],input:checked+&.wsui-is-interactive:is(label){", _ref5 => {
  let {
    theme,
    activeStyle
  } = _ref5;
  return parseStyle(activeStyle, theme);
}, ";&.wsui-is-interactive:hover:not(\n        input:disabled + &.wsui-is-interactive:is(label)\n      ),&:focus,input:focus+&:is(label){", _ref6 => {
  let {
    theme,
    activeHoverStyle
  } = _ref6;
  return parseStyle(activeHoverStyle, theme);
}, ";}}&.wsui-is-disabled,&:disabled,input:disabled+&.wsui-is-interactive:is(label){pointer-events:none;", _ref7 => {
  let {
    theme,
    disabledStyle
  } = _ref7;
  return parseStyle(disabledStyle, theme);
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const Button = forwardRef(function Button2(props, ref) {
  props = useThemeProps({
    props,
    name: "Button",
    handleVariant: true
  });
  let {
    color = "gray",
    hoverColor = "hover",
    activeColor = "active",
    activeHoverColor = "hover",
    disabledColor = "gray",
    style = {},
    hoverStyle = {},
    focusStyle = {},
    activeStyle = {},
    activeHoverStyle = {},
    disabledStyle = {},
    width,
    align,
    ...forwardedProps
  } = props;
  style = {
    backgroundColor: [color],
    color: [color, "text"],
    width,
    textAlign: align,
    justifyContent: align,
    justifyItems: align,
    ...style
  };
  hoverStyle = {
    backgroundColor: [style.backgroundColor || color, hoverColor],
    color: [style.backgroundColor || color, hoverColor, "text"],
    ...hoverStyle
  };
  focusStyle = {
    // outlineOffset: "1px",
    // outlineStyle: "solid",
    // outlineWidth: "2px",
    ...focusStyle
  };
  activeStyle = {
    backgroundColor: [style.backgroundColor || color, activeColor],
    color: [style.backgroundColor || color, activeColor, "text"],
    ...activeStyle
  };
  activeHoverStyle = {
    backgroundColor: [activeStyle.backgroundColor, activeHoverColor],
    color: [activeStyle.backgroundColor, activeHoverColor, "text"],
    ...activeHoverStyle
  };
  disabledStyle = {
    backgroundColor: [style.backgroundColor || color, disabledColor],
    color: [style.backgroundColor || color, disabledColor, "text"],
    ...disabledStyle
  };
  return /* @__PURE__ */jsx(ButtonRoot, {
    ref,
    style,
    hoverStyle,
    focusStyle,
    activeStyle,
    disabledStyle,
    activeHoverStyle,
    ...forwardedProps
  });
});
export { Button as default };